import { configureJotaiStore } from '@/state'
import {
  emailLinkWorkOrderIdAtom,
  initialWorkOrderIdAtom,
  loggedInEmailAtom,
  loginRequestAtom,
} from '@/state/authentication/login'
import {
  dashboardInfoAtom,
  packageDocumentDetailsAtom,
  readOnlyRequestAtom,
  selectedWorkOrderIdAtom,
} from '@/state/dashboard'
import {
  activeVerificationWorkOrderIndexAtom,
  verificationInfoAtom,
} from '@/state/verification'
import { dialogAtom } from '@/state/dialog/atom'
import { registrationEmailAtom } from '@/state/global'

export function clearSessionState() {
  const store = configureJotaiStore()

  sessionStorage.removeItem('isSignedIn')

  store.set(registrationEmailAtom, '')
  store.set(initialWorkOrderIdAtom, null)
  store.set(emailLinkWorkOrderIdAtom, null)
  store.set(loggedInEmailAtom, null)
  store.set(loginRequestAtom, null)

  store.set(selectedWorkOrderIdAtom, null)
  store.set(readOnlyRequestAtom, null)
  store.set(dashboardInfoAtom, { isLoading: false, data: null })
  store.set(packageDocumentDetailsAtom, { isLoading: false, data: null })
  store.set(verificationInfoAtom, { isLoading: false, data: null })
  store.set(activeVerificationWorkOrderIndexAtom, 0)
  store.set(dialogAtom, { type: null, data: undefined })
}
